import emojiLeft from "../../assets/emoji-left.svg";
import emojiRight from "../../assets/emoji-right.svg";
import emojiParty from "../../assets/emoji-party.svg";
import emojiConfetti from "../../assets/emoji-confetti.svg";

const AnnouncementBar = () => {
  return (
    <div className="top-0 z-50 w-full">
      <div className="relative bg-[#FFE9AC] py-2 px-3 text-center text-gray-800 text-[13px] sm:text-sm md:text-base font-medium flex items-center justify-center">
        <div className="absolute left-0 top-1/2 transform -translate-y-1/2">
          <img src={emojiLeft} alt="emoji" className="h-5 w-5 sm:h-6 sm:w-6" />
        </div>
        <div className="flex flex-wrap items-center justify-center gap-1 px-6">
          <span className="hidden sm:flex items-center gap-1">
            <img
              src={emojiConfetti}
              alt="confetti"
              className="h-4 w-4 sm:h-5 sm:w-5"
            />
          </span>
          <span className="text-[11px] sm:text-[12px] md:text-[13px]">
            We are proud to announce that we have completed&nbsp;
            <span className="text-green-700 font-semibold">
              7 successful years!
            </span>
          </span>
          <span className="hidden sm:flex items-center gap-1">
            <img
              src={emojiParty}
              alt="party"
              className="h-4 w-4 sm:h-5 sm:w-5"
            />
            <img
              src={emojiConfetti}
              alt="confetti"
              className="h-4 w-4 sm:h-5 sm:w-5"
            />
          </span>
        </div>
        <div className="absolute right-0 top-1/2 transform -translate-y-1/2">
          <img src={emojiRight} alt="emoji" className="h-5 w-5 sm:h-6 sm:w-6" />
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBar;
